import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://298bf7eaf464ac2e335d4ae669380fbf@o4511586904309760.ingest.de.sentry.io/4511586905620560",
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  }
});

async function enableMocking() {
  if (import.meta.env.MODE !== "development") return;
  const { worker } = await import("./mocks/browser");
  return worker.start({ onUnhandledRequest: "bypass" });
}

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

enableMocking().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
